import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=226c0279"
import script from "./InputError.vue?vue&type=script&lang=js"
export * from "./InputError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226c0279')) {
      api.createRecord('226c0279', component.options)
    } else {
      api.reload('226c0279', component.options)
    }
    module.hot.accept("./InputError.vue?vue&type=template&id=226c0279", function () {
      api.rerender('226c0279', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/InputError.vue"
export default component.exports